import styled from "styled-components";

export const TourGuideContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const TourGuideInfos = styled.div`
  display: flex;
  align-items: center;
  gap: 1.8rem;
`;

export const TourGuideType = styled.p`
  font-weight: 700;
  margin-right: 2.25rem;
  text-transform: uppercase;
  font-size: 1.4rem;
  letter-spacing: 1px;
  width: 10rem;
`;

export const TourGuideName = styled.p`
  font-size: 1.4rem;
  font-weight: 400;
  text-transform: capitalize;
  letter-spacing: 1px;
`;
